import { render } from "./TradesCard.vue?vue&type=template&id=02853249&scoped=true"
import script from "./TradesCard.vue?vue&type=script&lang=js"
export * from "./TradesCard.vue?vue&type=script&lang=js"

import "./TradesCard.vue?vue&type=style&index=0&id=02853249&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02853249"]])

export default __exports__